<section [ngClass]="{'side-by-side' : inline }">
  <div class="clear-input" [ngClass]="{'disabled' : disabled || (_maxChips && chips.length >= _maxChips)}"
    [matTooltip]="(_maxChips && chips.length >= _maxChips) ? 'Maximum of ' + _maxChips + ' already added.' : tooltip" matTooltipShowDelay="500">
    <input [type]="inputType" class="full-width" [placeholder]="_maxChips ? placeholder + ' (Max ' + _maxChips + ') ' : placeholder"
      [readonly]="disabled || (_maxChips && chips.length >= _maxChips)" min="0"
      (keydown.enter)="onAddChip(chipInput.value)" #chipInput>
      <i class="return-icon" [ngClass]="{'green' : addingChip}" (click)="onAddChip(chipInput.value)" title="Hit 'Enter' to add"></i>
      <mat-icon fontIcon="close" class="clear-icon" (click)="clearInput(chipInput, true)" [title]="chipInput.value ? 'Clear' : ''"></mat-icon>
    </div>
    @if (chips.length > 0) {
      <div class="chips-container" @appearHeight>
        @for (chip of chips; track $index) {
          <button class="chip" [title]="chip ? '' : 'Empty value'" tabindex="-1" @appearWidth>
            {{chip}}
            <mat-icon fontIcon="close" class="remove-chip" title="Remove {{chip}}"
            (click)="onRemoveChip(chip)" (keydown.enter)="onRemoveChip(chip)" (keydown.space)="onRemoveChip(chip)" tabindex="0"></mat-icon>
          </button>
        }
      </div>
    }
  </section>
